import { render, staticRenderFns } from "./homeView.vue?vue&type=template&id=587c83e7&"
import script from "./homeView.vue?vue&type=script&lang=js&"
export * from "./homeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports